module.exports = __webpack_public_path__ + "img/1526202361.d6c8c91a.jpg";